const NO_BLOCK = 'useTranslations() needs a <translations> block in this .vue file';

/**
 * The live Messages of this `.vue` file's `<translations>` block: the same object an import of
 * a Translation file gives. Auto-imported; do not import it, or the per-file declaration conflicts.
 *
 * The Vite plugin passes the block (`useTranslations()` → `useTranslations(block)`), and `volar.cjs`
 * re-declares it in each `.vue` file with a block, returning that block's type. The signature here is what
 * every other call sees: its `this` type fails the call, quoting the reason.
 */
export const useTranslations = ((translations?: object) => {
    if (translations === undefined) throw new Error(`i18n: ${NO_BLOCK}`);
    return translations;
}) as unknown as (this: typeof NO_BLOCK) => never;
